<!-- <p>action-details works!</p> -->
<div class="main-events-div">
    <div>
        <div class="title-div">
            <span *ngIf="action" style="font-size: large; font-weight: bolder;">Action:
                {{getActionTypeFromValue(action.ActionType)}} on {{action.AssetName}}</span>
            <span class="toolbar-spacer"></span>
            <button mat-raised-button (click)="back()" style="margin: 0.25em; margin-bottom: 0.5em;" class="app-icon--back">
                <mat-icon/>
                <span>Back</span>
            </button>
        </div>
        <div class="button-div">
            <button style="margin-right: 0.5em;" *ngIf="asset" mat-raised-button color="primary" (click)="goToAsset()" class="app-icon--goto">
                <span>Go To Asset</span>
                <mat-icon/>
            </button>
            <button style="margin-right: 0.5em;" *ngIf="action && action.EventID != 0" mat-raised-button color="primary" class="app-icon--goto"
                (click)="goToEvent()">
                <span>Go To Event</span>
                <mat-icon/>
            </button>
            <button style="margin-right: 0.5em;" *ngIf="rule" mat-raised-button color="primary" (click)="OpenRule(rule)">
                <span>View Rule</span>
                <mat-icon>visibility_on</mat-icon>
            </button>
            <button *ngIf="action" mat-raised-button (click)="editAction(action)">
                <span>Edit Action</span>
                <mat-icon>edit</mat-icon>
            </button>
            <span class="toolbar-spacer"></span>
            <button mat-raised-button (click)="goToActions()" style="margin-bottom: 0.5em;">
                <mat-icon>content_paste</mat-icon>
                <span>Actions</span>
            </button>
        </div>
        <br>
        <div class="image alignColumn alignRow" *ngIf="asset">
            <img (click)="viewImage(imagePathAssets() + asset.AssetID + '?' + asset.Modified)"
                src="{{imagePathAssets()}}{{asset.AssetID}}?{{asset.Modified}}" alt="{{asset.Name}}"
                onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'" />
        </div>
        <br>
        <div *ngIf="action && checkIfOverdue()">
            <span style="color: var(--action-bg-color); font-size: large; font-weight: bolder;" class="alignColumn">ACTION OVERDUE</span>
        </div>
        <div *ngIf="action && asset" [ngStyle]="{'border': checkIfOverdue() ? '2px solid var(--action-bg-color)': ''}" class="created-details" style="margin-bottom: 0.5em;">
            <span>Assigned To:</span>
            <span *ngIf="action.AssignedToUserSub" style="font-weight: bold;">{{ action.AssignedToUserSub }}</span>
            <span>Target Completion Date:</span>
            <span *ngIf="action.TargetCompletionTimestamp != undefined" style="font-weight: bold;">{{ convertEpochNoTime(action.TargetCompletionTimestamp) }}</span>
        </div>
        <div *ngIf="action && asset" class="rule-event-details">
            <span>Asset:</span>
            <span style="font-weight: bold;">{{ asset.Name }} - {{ asset.Description }}</span>
            <span>Action Type:</span>
            <span style="font-weight: bold;">{{ getActionTypeFromValue(action.ActionType) }}</span>
            <span *ngIf="action.WorkOrderReference != ''">Work Order Reference:</span>
            <span *ngIf="action.WorkOrderReference != ''">{{ action.WorkOrderReference }}</span>
            <span>Details:</span>
            <span>{{ action.Details }}</span>
        </div>
        <div *ngIf="action && asset" class="created-details" style="margin-top: 0.5em;">
            <span>Created by:</span>
            <span style="font-weight: bold;">{{ action.CreatedByUserSub }}</span>
            <span>Date Created:</span>
            <span style="font-weight: bold;">{{ convertEpoch(action.Timestamp) }}</span>
        </div>
        <br>
        <ejs-accordion>
            <e-accordionitems>
                <e-accordionitem [expanded]="expanded">
                    <ng-template #header>
                        <span *ngIf="comments">Comments ({{comments.length}})</span>
                        <span *ngIf="!comments">Comments (0)</span>
                    </ng-template>
                    <ng-template #content>
                        <div *ngIf="comments && comments.length > 0">
                            <div class="comment-info-div">
                                <span>Comment Text</span>
                                <span>Timestamp</span>
                                <span>Added By</span>
                            </div>
                            <div *ngFor="let c of comments">
                                <div class="comment-div">
                                    <span>{{ c.CommentText }}</span>
                                    <span *ngIf="c.Timestamp">{{ convertEpoch(c.Timestamp) }}</span>
                                    <span *ngIf="c.AddedByUserID">{{ c.AddedByUserID }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="add-comment-button-div">
                            <div class="add-button app-icon app-icon--add" (click)="addCommentNew()">
                                <span>Add Comment</span>
                                <mat-icon />
                            </div>
                        </div>
                    </ng-template>
                </e-accordionitem>
            </e-accordionitems>
        </ejs-accordion>
        <div class="acknowledge-button alignRow">
            <button mat-raised-button (click)="completeAction(true, false)" [disabled]="Acknowledged">
                <mat-icon>done</mat-icon>
                <span>Mark as Complete</span>
            </button>
        </div>
        <span class="acknowledge-button alignRow" *ngIf="Acknowledged && action">Marked as Complete by {{
            action.CompletedByUserID }} on {{ convertEpoch(action.CompletedTimestamp) }}</span>
    </div>
    <hr *ngIf="displayTimeline">
    <ejs-accordion id="timeline-accordion" *ngIf="displayTimeline">
        <e-accordionitems>
            <e-accordionitem>
                <ng-template #header>
                    <span>Timeline</span>
                </ng-template>
                <ng-template #content>
                    <div>
                        <ng-container *ngTemplateOutlet="timeline"></ng-container>
                    </div>
                </ng-template>
            </e-accordionitem>
        </e-accordionitems>
    </ejs-accordion>
</div>

<ng-template #timeline>
    <div *ngIf="Timeline && Timeline.length > 0" class="timeline-div alignColumn">
        <ejs-timeline orientation="Vertical" alignment="Before" [template]="customTemplate" cssClass="custom-timeline">
            <e-items>
                <e-item *ngFor="let item of timelineItems" [dotCss]="item.dotCss" [content]="item.content"
                    [oppositeContent]="item.oppositeContent">
                </e-item>
            </e-items>
            <ng-template #customTemplate let-data="">
                <div class='template-container'>
                    <div class="progress-line" [ngClass]="{'last': checkNotLast(data)}">
                        <div class="indicator alignRow alignColumn">
                            <mat-icon *ngIf="data.item.dotCss == '1'"
                                style="z-index: 1001;">notifications_active</mat-icon>
                            <mat-icon *ngIf="data.item.dotCss == '2'" style="z-index: 1001;">done</mat-icon>
                            <mat-icon *ngIf="data.item.dotCss == '3'" style="z-index: 1001;">restore</mat-icon>
                            <mat-icon *ngIf="data.item.dotCss == '4' || data.item.dotCss == '6'"
                                style="z-index: 1001;">comment</mat-icon>
                            <mat-icon *ngIf="data.item.dotCss == '5'" style="z-index: 1001;">content_paste</mat-icon>
                            <mat-icon *ngIf="data.item.dotCss == '7'"
                                style="z-index: 1001;">assignment_turned_in</mat-icon>
                            <mat-icon *ngIf="data.item.dotCss == '8' || data.item.dotCss == '9'"
                                style="z-index: 1001;">rules</mat-icon>
                            <mat-icon *ngIf="data.item.dotCss == '10'" style="z-index: 1001;">edit</mat-icon>
                        </div>
                    </div>
                    <div class="timeline-content">
                        <div class="content-container alignRow">
                            <div class="timeline-element"
                                *ngIf="data.item.dotCss == '1' && buildObject(data.item.content, data.item.dotCss) as RuleEvent">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                    <span>Event Created</span>
                                    <span class="toolbar-spacer"></span>
                                    <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                </div>
                                <br>
                                <div class="timeline-item">
                                    <span class="timeline-item-title">Rule</span>
                                    <span class="timeline-item-title">Asset</span>
                                    <span class="timeline-item-title">Timestamp</span>
                                    <span>{{RuleEvent.RuleName}}</span>
                                    <span>{{RuleEvent.AssetName}}</span>
                                    <span>{{convertEpoch(RuleEvent.TimeStamp)}}</span>
                                </div>
                            </div>
                            <div class="timeline-element"
                                *ngIf="data.item.dotCss == '2' && buildObject(data.item.content, data.item.dotCss) as RuleEvent">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                    <span>Event Acknowledged</span>
                                    <span class="toolbar-spacer"></span>
                                    <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                </div>
                                <br>
                                <div class="timeline-item">
                                    <span class="timeline-item-title">Rule</span>
                                    <span class="timeline-item-title">Asset</span>
                                    <span class="timeline-item-title">Timestamp</span>
                                    <span>{{RuleEvent.RuleName}}</span>
                                    <span>{{RuleEvent.AssetName}}</span>
                                    <span>{{convertEpoch(RuleEvent.TimeStamp)}}</span>
                                </div>
                            </div>
                            <div class="timeline-element"
                                *ngIf="data.item.dotCss == '3' && buildObject(data.item.content, data.item.dotCss) as RuleEvent">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                    <span>Event Re-Opened</span>
                                    <span class="toolbar-spacer"></span>
                                    <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                </div>
                                <br>
                                <div class="timeline-item">
                                    <span class="timeline-item-title">Rule</span>
                                    <span class="timeline-item-title">Asset</span>
                                    <span class="timeline-item-title">Timestamp</span>
                                    <span>{{RuleEvent.RuleName}}</span>
                                    <span>{{RuleEvent.AssetName}}</span>
                                    <span>{{convertEpoch(RuleEvent.TimeStamp)}}</span>
                                </div>
                            </div>
                            <div class="timeline-element"
                                *ngIf="data.item.dotCss == '4'  && buildObject(data.item.content, data.item.dotCss) as Comment">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                    <span>Event Comment Added</span>
                                    <span class="toolbar-spacer"></span>
                                    <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                </div>
                                <br>
                                <div class="timeline-item">
                                    <span class="timeline-item-title">Comment Text</span>
                                    <span class="timeline-item-title">Added By</span>
                                    <span class="timeline-item-title">Timestamp</span>
                                    <span>{{Comment.CommentText}}</span>
                                    <span>{{Comment.AddedByUserID}}</span>
                                    <span>{{convertEpoch(Comment.Timestamp)}}</span>
                                </div>
                            </div>
                            <div class="timeline-element"
                                *ngIf="data.item.dotCss == '5' && buildObject(data.item.content, data.item.dotCss) as Action">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                    <span>Action Created</span>
                                    <span class="toolbar-spacer"></span>
                                    <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                </div>
                                <br>
                                <div class="timeline-item">
                                    <span class="timeline-item-title">Asset</span>
                                    <span class="timeline-item-title">Action Type</span>
                                    <span class="timeline-item-title">Details</span>
                                    <span>{{Action.AssetName}}</span>
                                    <span>{{getActionTypeFromValue(Action.ActionType)}}</span>
                                    <span>{{Action.Details}}</span>
                                </div>
                            </div>
                            <div class="timeline-element"
                                *ngIf="data.item.dotCss == '6' && buildObject(data.item.content, data.item.dotCss) as Comment">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                    <span>Action Comment Added</span>
                                    <span class="toolbar-spacer"></span>
                                    <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                </div>
                                <br>
                                <div class="timeline-item">
                                    <span class="timeline-item-title">Comment Text</span>
                                    <span class="timeline-item-title">Added By</span>
                                    <span class="timeline-item-title">Timestamp</span>
                                    <span>{{Comment.CommentText}}</span>
                                    <span>{{Comment.AddedByUserID}}</span>
                                    <span>{{convertEpoch(Comment.Timestamp)}}</span>
                                </div>
                            </div>
                            <div class="timeline-element"
                                *ngIf="data.item.dotCss == '7' && buildObject(data.item.content, data.item.dotCss) as Action">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                    <span>Action Completed</span>
                                    <span class="toolbar-spacer"></span>
                                    <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                </div>
                                <br>
                                <div class="timeline-item">
                                    <span class="timeline-item-title">Asset</span>
                                    <span class="timeline-item-title">Action Type</span>
                                    <span class="timeline-item-title">Details</span>
                                    <span>{{Action.AssetName}}</span>
                                    <span>{{getActionTypeFromValue(Action.ActionType)}}</span>
                                    <span>{{Action.Details}}</span>
                                </div>
                            </div>
                            <div class="timeline-element"
                                *ngIf="data.item.dotCss == '8' && buildObject(data.item.content, data.item.dotCss) as Rule">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                    <span>Rule Disabled</span>
                                    <span class="toolbar-spacer"></span>
                                    <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                </div>
                                <br>
                                <div class="timeline-item">
                                    <span class="timeline-item-title">Rule</span>
                                    <span></span>
                                    <span></span>
                                    <span>{{Rule.RuleDescription}}</span>
                                </div>
                            </div>
                            <div class="timeline-element"
                                *ngIf="data.item.dotCss == '9' && buildObject(data.item.content, data.item.dotCss) as Rule">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                    <span>Rule Re-Enabled</span>
                                    <span class="toolbar-spacer"></span>
                                    <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                </div>
                                <br>
                                <div class="timeline-item">
                                    <span class="timeline-item-title">Rule</span>
                                    <span></span>
                                    <span></span>
                                    <span>{{Rule.RuleDescription}}</span>
                                </div>
                            </div>
                            <div class="timeline-element"
                                *ngIf="data.item.dotCss == '10' && buildObject(data.item.content, data.item.dotCss) as RuleEdit">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                    <span>Rule Changed</span>
                                    <span class="toolbar-spacer"></span>
                                    <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                </div>
                                <br>
                                <div class="timeline-item">
                                    <span class="timeline-item-title">Previous Conditions</span>
                                    <span class="timeline-item-title">New Conditions</span>
                                    <span class="timeline-item-title">Changed By</span>
                                    <span>{{RuleEdit.PreviousConditions}}</span>
                                    <span>{{RuleEdit.NewConditions}}</span>
                                    <span>{{RuleEdit.UserID}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </ejs-timeline>
    </div>
</ng-template>
